module.exports = __webpack_public_path__ + "img/logo-hearx-light.ce6f345f.png";